import React from 'react'

const ResourcesDropdown = ({ show, getLink, mobile = false }) => {
    return (
        <div
            className={`dropdown-menu--js-target resources-dropdown ${
                show ? 'active' : ''
            }`}
        >
            <div className="resources-dropdown__list">
                <div className={'resources-dropdown__title'}>
                    Popular resources
                </div>

                <ul className={'resources-dropdown__ul'}>
                    <li className={'resources-dropdown__li'}>
                        <a href="http://blog.homespotter.com/">Blog</a>
                    </li>
                    <li className={'resources-dropdown__li'}>
                        {getLink(
                            '/resources/adwerx-alternative',
                            'Boost vs Adwerx'
                        )}
                    </li>
                </ul>
            </div>
        </div>
    )
}

export default ResourcesDropdown
